export default __webpack_public_path__ + "static/media/Corsairs-treasure-07.aa284325.png";